import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

export interface HostName {
  hostName: string;
}

@Component({
  selector: 'ml-host-name-ui',
  templateUrl: './host-name.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule],
})
export class ManagedSettingsHostNameComponent {
  private readonly fb = inject(UntypedFormBuilder);
  private cd = inject(ChangeDetectorRef);

  readonly hostName = output<HostName>();

  public readonly hostNameForm = this.fb.group({
    hostName: '',
  });

  onSubmit() {
    this.hostName.emit(this.hostNameForm.value);
  }
}
